<template>
  <div class="container mel-glass-panel mel-glass-panel-content">
    <div class="row">
      <div class="col">
        <div class="mel-divider mel-divider-success d-flex align-items-center my-3">
          <p class="text-center fw-bold mx-3 mb-0 text-primary">{{ $t('page.site.title') }}</p>
        </div>
        <ul class="nav nav-pills flex-column">
          <li v-for="site in sortedSites" :key="site.id" class="text-nowrap">
            <a @click="select_site(site.id)" href="#" class="nav-link text-decoration-none"
              :class="{ 'active': selectedSiteId === site.id }">
              <font-awesome-layers class="fa-1x me-2">
                <font-awesome-icon :icon="['fas', 'warehouse']" />
              </font-awesome-layers>
              <span class="ms-1">
                <span v-if="hasMultipleTenants">{{ site.tenant.name }} - </span>{{ site.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue';
import { router } from '@/services/router';
import { storeToRefs } from 'pinia';
import { useSessionStore } from '@/stores';

const sessionStore = useSessionStore();
const { userSites, selectedSiteId } = storeToRefs(sessionStore);

const select_site = async (id: number) => {
  await sessionStore.selectSite(id);
  const backUrl = router.options.history.state.back as string | undefined;
  if (!backUrl) {
    router.push({ name: 'home' });
    return;
  }
  const route = router.resolve({ path: `${backUrl}` });
  if (route.meta.siteSpecificEntity) {
    router.push({ name: 'home' });
    return;
  }
  router.push(route.href);
};

onBeforeMount(async () => {
  // auto-route if user has only one site (nothing to select)
  if (userSites.value.length == 1) {
    await sessionStore.selectSite(userSites.value[0]!.id);
    router.push({ name: 'home' });
  }
});

const sortedSites = computed(() => {
  return [...userSites.value]?.sort((a, b) => a.tenant.name.localeCompare(b.tenant.name) || a.name.localeCompare(b.name));
});

const hasMultipleTenants = computed(() => {
  if (userSites.value.length == 0) return false;
  return userSites.value.some(site => site.tenant.id !== userSites.value[0]!.tenant.id);
});

</script>

<style scoped>
.mel-glass-panel-content {
  transition: all 0.4s ease 0s;
  max-width: 348px;
  padding: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 768px) {
  .mel-glass-panel-content {
    left: calc(50% + 280px);
    transform: translate(calc(-50% - 140px), -50%);
  }
}
</style>
